import DetailsPageContent from "./details-page-content";

export default DetailsPageContent;